const mapCodesOnly = (codes) => Array.isArray(codes) && codes.map((code) => code.code);
export default mapCodesOnly;
